<template>
  <div class="skill-inf-list ccs-fields">
    <ccs-header
      :title="skill.name_rus"
      :tag="skill.code"
      :info="false"/>
    <details v-for="zone in zones" :key="zone.id">
      <summary>
        {{ zone.name }}
        <img src="@/assets/icons/details_arrow.svg" alt=""
          class="summary-icon">
      </summary>
      <ccs-table :data="zone.equipments" :columnsDefs="columnsDefs">
        <template v-slot:status="props">
          {{ props.isEmpty ? 'Неизвестно' : parseEquipmentStatus(props.row.status) }}
        </template>
        <template v-slot:sponsor="props">
          {{ props.isEmpty ? 'Отсутствует' : props.row.sponsor.name }}
        </template>
      </ccs-table>
    </details>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

import Header from '@/layouts/Header.vue';
import Table from '@/components/Table.vue';

export default {
  name: 'PublicInfList',
  components: {
    'ccs-table': Table,
    'ccs-header': Header,
  },
  data() {
    return {
      currentZoneID: 0,
      columnsDefs: [
        {
          name: `name`,
          title: 'Наименование',
          prop: 'name',
        },
        {
          name: `description`,
          title: `Тех. описание или ссылка на сайт с тех. описанием позиции`,
          prop: `description`,
        },
        {
          name: `unit`,
          title: `Ед. изм.`,
          prop: `unit`,
          align: `center`,
        },
        {
          name: `count`,
          title: `Кол-во на уч.`,
          prop: `count`,
          align: `center`,
        },
        {
          name: `total_count`,
          title: `Всего`,
          prop: `total_count`,
          align: `center`,
        },
        {
          name: `status`,
          title: `Наличие`,
          prop: `status`,
          align: `center`,
        },
        {
          name: `sponsor`,
          title: `Поставщик\\Спонсор\\ответственный за обеспечение`,
          prop: `sponsor`,
          align: `center`,
        },
        {
          name: `price`,
          title: `Примерная стоимость всего, руб`,
          prop: `price`,
          align: `right`,
        },
        {
          name: `comment`,
          title: `Комментарий`,
          prop: `comment`,
        },
      ],
    };
  },
  computed: {
    ...mapState('skills', ['skill', 'zones']),
  },
  methods: {
    ...mapActions('skills', ['getPublicEquipments']),
    parseEquipmentStatus(equipment_status_slug) {
      if (equipment_status_slug === 'organizer') return 'Организатор';
      if (equipment_status_slug === 'union') return 'СОЮЗ';
      return 'Неизвестно';
    },
  },
  mounted() {
    this.getPublicEquipments(this.$route.params.code);
  },
};
</script>

<style lang="scss" scoped>
.skill-inf-list {
  min-height: 100%;
  min-width: 100%;
  background: $neutralLighter;

  .edit-header {
    padding: 15px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    .title {
      margin-bottom: 15px;
      font-size: 20px;
      font-weight: bold;
      color: $primary;
    }

  }

  .indicators {
    justify-content: space-between;

    .indicator {
      min-height: 56px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      &-val {
        font-size: 30px;
        font-weight: bold;
        height: 24px;
        color: $surfaceDarker;
      }

      &-text {
        padding: 0 10px;
        font-size: 12px;
        line-height: 150%;
        color: $neutralLight;
      }

    }

  }

  .area-info {
    margin: 10px 0 10px -33px;
    padding: 0 33px;
    width: 100%;
    min-height: 43px;
    display: flex;
    justify-content: stretch;
    align-items: stretch;
    background: $neutralLighter;

    &__content {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: stretch;
    }

    &__row {
      padding: 10px 15px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &__title {
      font-size: 12px;
      color: $neutralLight;
    }

    &__text {
      font-size: 16px;
      color: $surfaceDarker;
    }

  }

  details {
    padding: 15px;
    margin: 15px;
    width: calc(100% - 60px);
    box-shadow: 0px 0px 10px rgba(129, 129, 129, 0.2);
    border-radius: 5px;
    background: $neutralLighter;
    transition: background ease-in-out .2s;

    &[open] {
      padding-bottom: 0;
      background: #fff;

      > summary {
        color: $primary;
        transition: color ease-in-out .2s;

        > .summary-icon {
          transform: rotate(180deg);
        }

      }

    }

    > summary {
      padding: 10px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 20px;
      font-weight: bold;
      color: $surfaceDarker;

      &:hover {
        cursor: pointer;
      }

      &::-webkit-details-marker {
        display: none;
      }

      > .summary-icon {
        padding: 10px;
        margin-left: auto;
        height: 10px;
        width: 10px;
        justify-self: flex-end;
        transition: all ease-in-out .2s;
        border: 1px solid $primary;
        border-radius: 30px;
      }

      > .summary-icon:hover {
        cursor: pointer;
        background: $neutralLighter;
      }

    }

    .ccs-table, .break-line {
      margin-left: -15px;
      width: calc(100% + 30px);
    }

    .break-line {
      height: 20px;
      border-top: 1px solid #D8DDEF;
    }

    .ccs-table__actions {
      margin: 0 0 0 -15px;
      width: calc(100% + 30px);
      background: $neutralLighter;
      border-top: 1px solid #D8DDEF;
    }

    > .ccs-button {
      margin-bottom: 20px;
    }

  }

}
</style>
